module.exports = __webpack_public_path__ + "files/b36c87594f5f33eb46c864adc932a342.png";